// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ======================
   Videos Page

   Design System: Uses CSS variables from colors.css
   - Neutral base palette, accent reserved for primary actions only
   - Flat surfaces with borders (no gradients)
   - Minimal shadows, minimal border radii
   ====================== */

.videos-content {
  max-width: 1440px;
  margin: 0 auto;
  padding: 32px 24px 48px;
  min-height: 100%;
  width: 100%;
  box-sizing: border-box;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  background: var(--color-bg-root);
}

/* ======================
   HEADER
   ====================== */

.videos-header-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 20px;
  gap: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid var(--color-border-input);
}

.videos-header-copy {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.videos-title {
  margin: 0;
  font-size: 24px;
  font-weight: 500;
  line-height: 1.2;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.videos-subtitle {
  margin: 0;
  font-size: 13px;
  color: var(--color-text-secondary);
}

.videos-create-button {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 8px 14px;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease;
  white-space: nowrap;
}

.videos-create-button:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.videos-create-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.videos-create-button--large {
  padding: 10px 20px;
  font-size: 14px;
  margin-top: 16px;
}

/* ======================
   TOOLBAR
   ====================== */

.videos-toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}

.videos-search {
  position: relative;
  display: flex;
  align-items: center;
  flex: 1 1;
  max-width: 320px;
}

.videos-search__icon {
  position: absolute;
  left: 10px;
  color: var(--color-text-secondary);
  opacity: 0.7;
  pointer-events: none;
}

.videos-search__input {
  width: 100%;
  padding: 8px 12px 8px 30px;
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  background: var(--color-bg-input);
  font-size: 13px;
  color: var(--color-text-primary);
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
  box-sizing: border-box;
}

.videos-search__input:focus {
  outline: none;
  border-color: var(--color-text-secondary);
  box-shadow: 0 0 0 3px var(--color-focus-ring);
}

.videos-search__input::placeholder {
  color: var(--color-text-secondary);
  opacity: 0.75;
}

.videos-count {
  font-size: 12px;
  color: var(--color-text-secondary);
  white-space: nowrap;
  margin-left: auto;
}

/* ======================
   ERROR / LOADING / EMPTY
   ====================== */

.videos-error {
  background: var(--color-status-error-tint);
  border: 1px solid var(--color-status-error-border);
  color: var(--color-status-error-text);
  padding: 10px 14px;
  border-radius: 4px;
  margin-bottom: 16px;
  font-size: 13px;
  font-weight: 500;
}

@keyframes videos-spin {
  to {
    transform: rotate(360deg);
  }
}

.videos-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 72px 24px;
}

.videos-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  border: 1px solid var(--color-border-input);
  background: var(--color-bg-input);
  color: var(--color-text-secondary);
  margin-bottom: 16px;
}

.videos-empty-state h2 {
  margin: 0 0 6px;
  font-size: 20px;
  font-weight: 500;
  font-family: 'Geist Sans', 'Times New Roman', serif;
}

.videos-empty-state p {
  margin: 0;
  font-size: 13px;
  color: var(--color-text-secondary);
}

/* ======================
   GRID
   ====================== */

.videos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(224px, 1fr));
  gap: 16px;
  align-items: start;
}

/* ======================
   CARD
   ====================== */

.videos-card {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  overflow: hidden;
  background: var(--color-bg-canvas-surface);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.videos-card:hover:not(.videos-card--generating) {
  border-color: var(--color-text-secondary);
  box-shadow: 0 6px 18px -14px rgba(0, 0, 0, 0.55);
}

/* The whole tile is the remix target; the delete button sits on top of it,
   which is why the card itself is a plain element and not a <button>. */
.videos-card__surface {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 0;
  padding: 0;
  border: 0;
  background: none;
  color: inherit;
  font-family: inherit;
  line-height: normal;
  text-align: left;
  cursor: pointer;
}

.videos-card__surface:focus-visible {
  outline: 2px solid var(--color-focus-ring);
  outline-offset: -2px;
}

.videos-card__surface:disabled {
  cursor: default;
}

/* Uniform media frame — keeps every row aligned regardless of source ratio. */

.videos-card__frame {
  position: relative;
  width: 100%;
  aspect-ratio: 1;
  overflow: hidden;
  background: var(--color-bg-canvas);
  border-bottom: 1px solid var(--color-border-input);
}

.videos-card__media {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  background: var(--color-bg-canvas);
  transition: transform 0.35s ease;
}

.videos-card:hover:not(.videos-card--generating) .videos-card__media {
  transform: scale(1.03);
}

/* Placeholder (generating / failed / no preview) */

.videos-card__placeholder {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  height: 100%;
  color: var(--color-text-secondary);
  background: var(--color-bg-input);
  overflow: hidden;
}

.videos-card__placeholder-text {
  font-size: 11.5px;
  font-weight: 500;
}

.videos-card--failed .videos-card__placeholder {
  color: var(--color-status-error-text);
  background: var(--color-status-error-tint);
}

.videos-card__shimmer {
  position: absolute;
  inset: 0;
  background: linear-gradient(
    100deg,
    transparent 30%,
    var(--generating-glimmer-color) 50%,
    transparent 70%
  );
  background-size: 200% 100%;
  animation: videos-shimmer 1.6s ease-in-out infinite;
  opacity: 0.35;
}

@keyframes videos-shimmer {
  from {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}

/* Status badge (generating / failed) */

.videos-card__status {
  position: absolute;
  top: 8px;
  left: 8px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 3px;
  background: var(--color-bg-canvas-surface);
  border: 1px solid var(--color-border-input);
  color: var(--color-text-secondary);
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.videos-card__status--failed {
  color: var(--color-status-error-text);
  border-color: var(--color-status-error-border);
  background: var(--color-status-error-tint);
}

.videos-card__status-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: currentColor;
  animation: videos-pulse 1.4s ease-in-out infinite;
}

@keyframes videos-pulse {
  0%,
  100% {
    opacity: 0.35;
  }
  50% {
    opacity: 1;
  }
}

/* Play affordance — fades out as the preview starts on hover */

.videos-card__play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  backdrop-filter: blur(4px);
  opacity: 0.7;
  transition: opacity 0.15s ease;
  pointer-events: none;
}

.videos-card:hover .videos-card__play {
  opacity: 0;
}

/* Remix chip — revealed on hover, sits left of the delete button */

.videos-card__remix {
  position: absolute;
  top: 8px;
  right: 38px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 9px;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.62);
  color: #fff;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.02em;
  backdrop-filter: blur(6px);
  opacity: 0;
  transform: translateY(-3px);
  transition: opacity 0.15s ease, transform 0.15s ease;
  pointer-events: none;
}

.videos-card:hover .videos-card__remix {
  opacity: 1;
  transform: translateY(0);
}

/* Delete — hover-only, minimal icon button */

.videos-card__delete {
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  border: 0;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.62);
  color: #fff;
  cursor: pointer;
  backdrop-filter: blur(6px);
  opacity: 0;
  transform: translateY(-3px);
  transition: opacity 0.15s ease, transform 0.15s ease, background 0.15s ease;
}

.videos-card:hover .videos-card__delete,
.videos-card__delete:focus-visible {
  opacity: 1;
  transform: translateY(0);
}

.videos-card__delete:hover {
  background: #b91c1c;
}

.videos-card__delete:focus-visible {
  outline: 2px solid var(--color-focus-ring);
  outline-offset: 1px;
}

/* Touch devices never hover, so keep the control visible but quiet. */
@media (hover: none) {
  .videos-card__delete {
    opacity: 0.85;
    transform: none;
  }
}

/* Inline confirm — scoped to the card instead of a full modal */

.videos-card__confirm {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  padding: 16px;
  text-align: center;
  background: rgba(0, 0, 0, 0.62);
  backdrop-filter: blur(4px);
  animation: videos-confirm-in 0.14s ease-out;
}

@keyframes videos-confirm-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.videos-card__confirm-text {
  margin: 0;
  font-size: 13px;
  font-weight: 500;
  color: #fff;
}

.videos-card__confirm-actions {
  display: flex;
  gap: 8px;
}

.videos-card__confirm-button {
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 500;
  font-family: inherit;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.videos-card__confirm-button:hover {
  background: rgba(255, 255, 255, 0.2);
}

.videos-card__confirm-button--danger {
  background: #b91c1c;
  border-color: #b91c1c;
}

.videos-card__confirm-button--danger:hover {
  background: #dc2626;
  border-color: #dc2626;
}

.videos-card__confirm-button:focus-visible {
  outline: 2px solid #fff;
  outline-offset: 1px;
}

/* Puff — the card inflates, blurs, and vanishes on delete */

.videos-card--removing {
  pointer-events: none;
  animation: videos-puff 320ms cubic-bezier(0.34, 0.1, 0.42, 1) forwards;
}

@keyframes videos-puff {
  0% {
    transform: scale(1);
    opacity: 1;
    filter: blur(0);
  }
  30% {
    transform: scale(1.05);
    opacity: 0.9;
    filter: blur(0);
  }
  100% {
    transform: scale(0.82);
    opacity: 0;
    filter: blur(9px);
  }
}

/* Ratio + duration chips */

.videos-card__chips {
  position: absolute;
  right: 8px;
  bottom: 8px;
  display: flex;
  align-items: center;
  gap: 4px;
  pointer-events: none;
}

.videos-card__chip {
  padding: 2px 6px;
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 10px;
  font-weight: 600;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
  backdrop-filter: blur(4px);
}

/* Card body */

.videos-card__body {
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 10px 12px 11px;
  background: var(--color-bg-sidebar);
}

.videos-card__prompt {
  margin: 0;
  font-size: 12.5px;
  font-weight: 500;
  line-height: 1.35;
  color: var(--color-text-primary);
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  /* Two lines always, so every card in a row ends at the same height. */
  min-height: calc(2 * 1.35em);
}

.videos-card__meta {
  display: flex;
  align-items: center;
  gap: 5px;
  min-width: 0;
  font-size: 11px;
  color: var(--color-text-secondary);
  white-space: nowrap;
}

.videos-card__model {
  flex-shrink: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}

.videos-card__time {
  margin-left: auto;
  padding-left: 6px;
  flex-shrink: 0;
  opacity: 0.8;
}

/* ======================
   SKELETON
   ====================== */

.videos-skeleton {
  border: 1px solid var(--color-border-input);
  border-radius: 6px;
  overflow: hidden;
  background: var(--color-bg-canvas-surface);
}

.videos-skeleton__frame {
  width: 100%;
  aspect-ratio: 1;
  background: var(--color-bg-input);
  border-bottom: 1px solid var(--color-border-input);
  animation: videos-skeleton-pulse 1.6s ease-in-out infinite;
}

.videos-skeleton__body {
  display: flex;
  flex-direction: column;
  gap: 7px;
  padding: 12px;
  background: var(--color-bg-sidebar);
}

.videos-skeleton__line {
  height: 9px;
  border-radius: 3px;
  background: var(--color-bg-input);
  animation: videos-skeleton-pulse 1.6s ease-in-out infinite;
}

.videos-skeleton__line--short {
  width: 55%;
}

@keyframes videos-skeleton-pulse {
  0%,
  100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
}

/* ======================
   LOAD MORE
   ====================== */

.videos-load-more-row {
  display: flex;
  justify-content: center;
  padding: 28px 0 8px;
}

.videos-load-more {
  padding: 8px 20px;
  font-size: 13px;
  font-weight: 500;
  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;
  background: var(--color-bg-input);
  color: var(--color-text-primary);
  border: 1px solid var(--color-border-input);
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.videos-load-more:hover:not(:disabled) {
  background: var(--color-bg-user-bubble);
}

.videos-load-more:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* ======================
   RESPONSIVE
   ====================== */

@media (max-width: 900px) {
  .videos-grid {
    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));
    gap: 14px;
  }
}

@media (max-width: 620px) {
  .videos-content {
    padding: 24px 16px 40px;
  }

  .videos-header-section {
    flex-direction: column;
    align-items: flex-start;
  }

  .videos-grid {
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 12px;
  }

  .videos-search {
    max-width: none;
  }
}

@media (prefers-reduced-motion: reduce) {
  .videos-card__media,
  .videos-card__shimmer,
  .videos-card__status-dot,
  .videos-skeleton__frame,
  .videos-skeleton__line {
    animation: none;
    transition: none;
  }

  .videos-card:hover:not(.videos-card--generating) .videos-card__media {
    transform: none;
  }

  /* Still fade out on delete, just without the inflate/blur. */
  .videos-card--removing {
    animation: videos-fade-out 160ms ease-out forwards;
  }

  @keyframes videos-fade-out {
    to {
      opacity: 0;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/VideosPage.css"],"names":[],"mappings":"AAAA;;;;;;;2BAO2B;;AAE3B;EACE,iBAAiB;EACjB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gCAAgC;EAChC,8EAA8E;EAC9E,gCAAgC;AAClC;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gCAAgC;EAChC,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,8EAA8E;EAC9E,iCAAiC;EACjC,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,kCAAkC;EAClC,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,2CAA2C;EAC3C,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gCAAgC;EAChC,8EAA8E;EAC9E,0DAA0D;EAC1D,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;;2BAE2B;;AAE3B;EACE,0CAA0C;EAC1C,kDAAkD;EAClD,qCAAqC;EACrC,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,iCAAiC;EACjC,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,mDAAmD;AACrD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,kCAAkC;AACpC;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,kBAAkB;AACpB;;AAEA;;2BAE2B;;AAE3B;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;EAC1C,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;EACzC,gDAAgD;AAClD;;AAEA;wEACwE;AACxE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA,8EAA8E;;AAE9E;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kCAAkC;EAClC,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;AACxB;;AAEA,mDAAmD;;AAEnD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,0BAA0B;EAC1B,mDAAmD;EACnD,aAAa;AACf;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA,uCAAuC;;AAEvC;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,0CAA0C;EAC1C,2CAA2C;EAC3C,kCAAkC;EAClC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,8CAA8C;EAC9C,0CAA0C;AAC5C;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,UAAU;EACZ;AACF;;AAEA,+DAA+D;;AAE/D;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,0BAA0B;EAC1B,YAAY;EACZ,8BAA8B;EAC9B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,mEAAmE;;AAEnE;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,oBAAoB;EACpB,+BAA+B;EAC/B,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,UAAU;EACV,2BAA2B;EAC3B,oDAAoD;EACpD,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA,6CAA6C;;AAE7C;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,+BAA+B;EAC/B,WAAW;EACX,eAAe;EACf,0BAA0B;EAC1B,UAAU;EACV,2BAA2B;EAC3B,2EAA2E;AAC7E;;AAEA;;EAEE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA,sEAAsE;AACtE;EACE;IACE,aAAa;IACb,eAAe;EACjB;AACF;;AAEA,gEAAgE;;AAEhE;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;EAC1B,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,2CAA2C;EAC3C,oCAAoC;EACpC,WAAW;EACX,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,4DAA4D;;AAE5D;EACE,oBAAoB;EACpB,sEAAsE;AACxE;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;IACV,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,YAAY;IACZ,eAAe;EACjB;EACA;IACE,sBAAsB;IACtB,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA,2BAA2B;;AAE3B;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,cAAc;;AAEd;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,sEAAsE;EACtE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;;AAEA;;2BAE2B;;AAE3B;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,kDAAkD;EAClD,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iCAAiC;EACjC,0DAA0D;AAC5D;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;;IAEE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;2BAE2B;;AAE3B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,8EAA8E;EAC9E,iCAAiC;EACjC,gCAAgC;EAChC,2CAA2C;EAC3C,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;2BAE2B;;AAE3B;EACE;IACE,4DAA4D;IAC5D,SAAS;EACX;AACF;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;;;IAKE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA,6DAA6D;EAC7D;IACE,kDAAkD;EACpD;;EAEA;IACE;MACE,UAAU;IACZ;EACF;AACF","sourcesContent":["/* ======================\n   Videos Page\n\n   Design System: Uses CSS variables from colors.css\n   - Neutral base palette, accent reserved for primary actions only\n   - Flat surfaces with borders (no gradients)\n   - Minimal shadows, minimal border radii\n   ====================== */\n\n.videos-content {\n  max-width: 1440px;\n  margin: 0 auto;\n  padding: 32px 24px 48px;\n  min-height: 100%;\n  width: 100%;\n  box-sizing: border-box;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  background: var(--color-bg-root);\n}\n\n/* ======================\n   HEADER\n   ====================== */\n\n.videos-header-section {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-end;\n  margin-bottom: 20px;\n  gap: 16px;\n  padding-bottom: 16px;\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.videos-header-copy {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.videos-title {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 500;\n  line-height: 1.2;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.videos-subtitle {\n  margin: 0;\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n\n.videos-create-button {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 14px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n  white-space: nowrap;\n}\n\n.videos-create-button:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.videos-create-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.videos-create-button--large {\n  padding: 10px 20px;\n  font-size: 14px;\n  margin-top: 16px;\n}\n\n/* ======================\n   TOOLBAR\n   ====================== */\n\n.videos-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 18px;\n}\n\n.videos-search {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex: 1;\n  max-width: 320px;\n}\n\n.videos-search__icon {\n  position: absolute;\n  left: 10px;\n  color: var(--color-text-secondary);\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n.videos-search__input {\n  width: 100%;\n  padding: 8px 12px 8px 30px;\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  background: var(--color-bg-input);\n  font-size: 13px;\n  color: var(--color-text-primary);\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n  box-sizing: border-box;\n}\n\n.videos-search__input:focus {\n  outline: none;\n  border-color: var(--color-text-secondary);\n  box-shadow: 0 0 0 3px var(--color-focus-ring);\n}\n\n.videos-search__input::placeholder {\n  color: var(--color-text-secondary);\n  opacity: 0.75;\n}\n\n.videos-count {\n  font-size: 12px;\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n  margin-left: auto;\n}\n\n/* ======================\n   ERROR / LOADING / EMPTY\n   ====================== */\n\n.videos-error {\n  background: var(--color-status-error-tint);\n  border: 1px solid var(--color-status-error-border);\n  color: var(--color-status-error-text);\n  padding: 10px 14px;\n  border-radius: 4px;\n  margin-bottom: 16px;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n@keyframes videos-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.videos-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 72px 24px;\n}\n\n.videos-empty-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  border: 1px solid var(--color-border-input);\n  background: var(--color-bg-input);\n  color: var(--color-text-secondary);\n  margin-bottom: 16px;\n}\n\n.videos-empty-state h2 {\n  margin: 0 0 6px;\n  font-size: 20px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'Times New Roman', serif;\n}\n\n.videos-empty-state p {\n  margin: 0;\n  font-size: 13px;\n  color: var(--color-text-secondary);\n}\n\n/* ======================\n   GRID\n   ====================== */\n\n.videos-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(224px, 1fr));\n  gap: 16px;\n  align-items: start;\n}\n\n/* ======================\n   CARD\n   ====================== */\n\n.videos-card {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  overflow: hidden;\n  background: var(--color-bg-canvas-surface);\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\n.videos-card:hover:not(.videos-card--generating) {\n  border-color: var(--color-text-secondary);\n  box-shadow: 0 6px 18px -14px rgba(0, 0, 0, 0.55);\n}\n\n/* The whole tile is the remix target; the delete button sits on top of it,\n   which is why the card itself is a plain element and not a <button>. */\n.videos-card__surface {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  border: 0;\n  background: none;\n  color: inherit;\n  font-family: inherit;\n  line-height: normal;\n  text-align: left;\n  cursor: pointer;\n}\n\n.videos-card__surface:focus-visible {\n  outline: 2px solid var(--color-focus-ring);\n  outline-offset: -2px;\n}\n\n.videos-card__surface:disabled {\n  cursor: default;\n}\n\n/* Uniform media frame — keeps every row aligned regardless of source ratio. */\n\n.videos-card__frame {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1;\n  overflow: hidden;\n  background: var(--color-bg-canvas);\n  border-bottom: 1px solid var(--color-border-input);\n}\n\n.videos-card__media {\n  display: block;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  background: var(--color-bg-canvas);\n  transition: transform 0.35s ease;\n}\n\n.videos-card:hover:not(.videos-card--generating) .videos-card__media {\n  transform: scale(1.03);\n}\n\n/* Placeholder (generating / failed / no preview) */\n\n.videos-card__placeholder {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  width: 100%;\n  height: 100%;\n  color: var(--color-text-secondary);\n  background: var(--color-bg-input);\n  overflow: hidden;\n}\n\n.videos-card__placeholder-text {\n  font-size: 11.5px;\n  font-weight: 500;\n}\n\n.videos-card--failed .videos-card__placeholder {\n  color: var(--color-status-error-text);\n  background: var(--color-status-error-tint);\n}\n\n.videos-card__shimmer {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    100deg,\n    transparent 30%,\n    var(--generating-glimmer-color) 50%,\n    transparent 70%\n  );\n  background-size: 200% 100%;\n  animation: videos-shimmer 1.6s ease-in-out infinite;\n  opacity: 0.35;\n}\n\n@keyframes videos-shimmer {\n  from {\n    background-position: 200% 0;\n  }\n  to {\n    background-position: -200% 0;\n  }\n}\n\n/* Status badge (generating / failed) */\n\n.videos-card__status {\n  position: absolute;\n  top: 8px;\n  left: 8px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 3px 8px;\n  border-radius: 3px;\n  background: var(--color-bg-canvas-surface);\n  border: 1px solid var(--color-border-input);\n  color: var(--color-text-secondary);\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.01em;\n}\n\n.videos-card__status--failed {\n  color: var(--color-status-error-text);\n  border-color: var(--color-status-error-border);\n  background: var(--color-status-error-tint);\n}\n\n.videos-card__status-dot {\n  width: 5px;\n  height: 5px;\n  border-radius: 50%;\n  background: currentColor;\n  animation: videos-pulse 1.4s ease-in-out infinite;\n}\n\n@keyframes videos-pulse {\n  0%,\n  100% {\n    opacity: 0.35;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n/* Play affordance — fades out as the preview starts on hover */\n\n.videos-card__play {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.4);\n  color: #fff;\n  backdrop-filter: blur(4px);\n  opacity: 0.7;\n  transition: opacity 0.15s ease;\n  pointer-events: none;\n}\n\n.videos-card:hover .videos-card__play {\n  opacity: 0;\n}\n\n/* Remix chip — revealed on hover, sits left of the delete button */\n\n.videos-card__remix {\n  position: absolute;\n  top: 8px;\n  right: 38px;\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  padding: 4px 9px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.62);\n  color: #fff;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  backdrop-filter: blur(6px);\n  opacity: 0;\n  transform: translateY(-3px);\n  transition: opacity 0.15s ease, transform 0.15s ease;\n  pointer-events: none;\n}\n\n.videos-card:hover .videos-card__remix {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n/* Delete — hover-only, minimal icon button */\n\n.videos-card__delete {\n  position: absolute;\n  top: 8px;\n  right: 8px;\n  z-index: 2;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 0;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.62);\n  color: #fff;\n  cursor: pointer;\n  backdrop-filter: blur(6px);\n  opacity: 0;\n  transform: translateY(-3px);\n  transition: opacity 0.15s ease, transform 0.15s ease, background 0.15s ease;\n}\n\n.videos-card:hover .videos-card__delete,\n.videos-card__delete:focus-visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.videos-card__delete:hover {\n  background: #b91c1c;\n}\n\n.videos-card__delete:focus-visible {\n  outline: 2px solid var(--color-focus-ring);\n  outline-offset: 1px;\n}\n\n/* Touch devices never hover, so keep the control visible but quiet. */\n@media (hover: none) {\n  .videos-card__delete {\n    opacity: 0.85;\n    transform: none;\n  }\n}\n\n/* Inline confirm — scoped to the card instead of a full modal */\n\n.videos-card__confirm {\n  position: absolute;\n  inset: 0;\n  z-index: 3;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  padding: 16px;\n  text-align: center;\n  background: rgba(0, 0, 0, 0.62);\n  backdrop-filter: blur(4px);\n  animation: videos-confirm-in 0.14s ease-out;\n}\n\n@keyframes videos-confirm-in {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.videos-card__confirm-text {\n  margin: 0;\n  font-size: 13px;\n  font-weight: 500;\n  color: #fff;\n}\n\n.videos-card__confirm-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.videos-card__confirm-button {\n  padding: 6px 14px;\n  font-size: 12px;\n  font-weight: 500;\n  font-family: inherit;\n  border-radius: 4px;\n  border: 1px solid rgba(255, 255, 255, 0.28);\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.videos-card__confirm-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n}\n\n.videos-card__confirm-button--danger {\n  background: #b91c1c;\n  border-color: #b91c1c;\n}\n\n.videos-card__confirm-button--danger:hover {\n  background: #dc2626;\n  border-color: #dc2626;\n}\n\n.videos-card__confirm-button:focus-visible {\n  outline: 2px solid #fff;\n  outline-offset: 1px;\n}\n\n/* Puff — the card inflates, blurs, and vanishes on delete */\n\n.videos-card--removing {\n  pointer-events: none;\n  animation: videos-puff 320ms cubic-bezier(0.34, 0.1, 0.42, 1) forwards;\n}\n\n@keyframes videos-puff {\n  0% {\n    transform: scale(1);\n    opacity: 1;\n    filter: blur(0);\n  }\n  30% {\n    transform: scale(1.05);\n    opacity: 0.9;\n    filter: blur(0);\n  }\n  100% {\n    transform: scale(0.82);\n    opacity: 0;\n    filter: blur(9px);\n  }\n}\n\n/* Ratio + duration chips */\n\n.videos-card__chips {\n  position: absolute;\n  right: 8px;\n  bottom: 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  pointer-events: none;\n}\n\n.videos-card__chip {\n  padding: 2px 6px;\n  border-radius: 3px;\n  background: rgba(0, 0, 0, 0.6);\n  color: #fff;\n  font-size: 10px;\n  font-weight: 600;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.01em;\n  backdrop-filter: blur(4px);\n}\n\n/* Card body */\n\n.videos-card__body {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 10px 12px 11px;\n  background: var(--color-bg-sidebar);\n}\n\n.videos-card__prompt {\n  margin: 0;\n  font-size: 12.5px;\n  font-weight: 500;\n  line-height: 1.35;\n  color: var(--color-text-primary);\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  /* Two lines always, so every card in a row ends at the same height. */\n  min-height: calc(2 * 1.35em);\n}\n\n.videos-card__meta {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  min-width: 0;\n  font-size: 11px;\n  color: var(--color-text-secondary);\n  white-space: nowrap;\n}\n\n.videos-card__model {\n  flex-shrink: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.videos-card__time {\n  margin-left: auto;\n  padding-left: 6px;\n  flex-shrink: 0;\n  opacity: 0.8;\n}\n\n/* ======================\n   SKELETON\n   ====================== */\n\n.videos-skeleton {\n  border: 1px solid var(--color-border-input);\n  border-radius: 6px;\n  overflow: hidden;\n  background: var(--color-bg-canvas-surface);\n}\n\n.videos-skeleton__frame {\n  width: 100%;\n  aspect-ratio: 1;\n  background: var(--color-bg-input);\n  border-bottom: 1px solid var(--color-border-input);\n  animation: videos-skeleton-pulse 1.6s ease-in-out infinite;\n}\n\n.videos-skeleton__body {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  padding: 12px;\n  background: var(--color-bg-sidebar);\n}\n\n.videos-skeleton__line {\n  height: 9px;\n  border-radius: 3px;\n  background: var(--color-bg-input);\n  animation: videos-skeleton-pulse 1.6s ease-in-out infinite;\n}\n\n.videos-skeleton__line--short {\n  width: 55%;\n}\n\n@keyframes videos-skeleton-pulse {\n  0%,\n  100% {\n    opacity: 0.6;\n  }\n  50% {\n    opacity: 1;\n  }\n}\n\n/* ======================\n   LOAD MORE\n   ====================== */\n\n.videos-load-more-row {\n  display: flex;\n  justify-content: center;\n  padding: 28px 0 8px;\n}\n\n.videos-load-more {\n  padding: 8px 20px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: 'Geist Sans', 'SF Pro Display', 'Segoe UI', system-ui, sans-serif;\n  background: var(--color-bg-input);\n  color: var(--color-text-primary);\n  border: 1px solid var(--color-border-input);\n  border-radius: 4px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.videos-load-more:hover:not(:disabled) {\n  background: var(--color-bg-user-bubble);\n}\n\n.videos-load-more:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* ======================\n   RESPONSIVE\n   ====================== */\n\n@media (max-width: 900px) {\n  .videos-grid {\n    grid-template-columns: repeat(auto-fill, minmax(190px, 1fr));\n    gap: 14px;\n  }\n}\n\n@media (max-width: 620px) {\n  .videos-content {\n    padding: 24px 16px 40px;\n  }\n\n  .videos-header-section {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .videos-grid {\n    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n    gap: 12px;\n  }\n\n  .videos-search {\n    max-width: none;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .videos-card__media,\n  .videos-card__shimmer,\n  .videos-card__status-dot,\n  .videos-skeleton__frame,\n  .videos-skeleton__line {\n    animation: none;\n    transition: none;\n  }\n\n  .videos-card:hover:not(.videos-card--generating) .videos-card__media {\n    transform: none;\n  }\n\n  /* Still fade out on delete, just without the inflate/blur. */\n  .videos-card--removing {\n    animation: videos-fade-out 160ms ease-out forwards;\n  }\n\n  @keyframes videos-fade-out {\n    to {\n      opacity: 0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
